import { enqueueError } from '@paragon/notification-tools';

import {
  pDelete as pDeleteView,
  pInsert as pInsertView,
  pOverwrite as pOverwriteView,
  pRemoveDefault as pRemoveDefaultView,
  pSetDefault as pSetDefaultView,
} from '../data/viewData';
import {
  finishDeletingView,
  finishOverwritingView,
  finishSavingView,
  removeDefaultViewFromStore,
  setDefaultViewWithId,
  View,
} from '../store/viewsSlice';
import { AsyncThunkActionVoid } from './thunkActionTypes';

export const saveView =
  (view: View, name: string): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    try {
      const insertedView = await pInsertView(
        getState().logInData.loggedInUser!.email,
        name,
        view.jobFilters,
        view.visibleColumns,
      );
      dispatch(finishSavingView(insertedView));
    } catch (err) {
      console.log(err);
    }
  };

export const overwriteView =
  (view: View, name: string): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const savedView = getState().views.savedViews.find((savedView) => savedView.name === name);
    if (!savedView) {
      dispatch(enqueueError('Unable to save filter.'));
      return;
    }

    try {
      const overwrittenView = await pOverwriteView(savedView.id, name, view.jobFilters, view.visibleColumns);
      dispatch(finishOverwritingView(overwrittenView));
    } catch (err) {
      console.log(err);
    }
  };

export const deleteView =
  (id: number): AsyncThunkActionVoid =>
  async (dispatch) => {
    try {
      await pDeleteView(id);
      dispatch(finishDeletingView(id));
    } catch (err) {
      console.log(err);
    }
  };

export const setDefaultView =
  (id: number): AsyncThunkActionVoid =>
  async (dispatch) => {
    await pSetDefaultView(id);
    dispatch(setDefaultViewWithId(id));
  };

export const removeDefaultView = (): AsyncThunkActionVoid => async (dispatch) => {
  await pRemoveDefaultView();
  dispatch(removeDefaultViewFromStore());
};
